export const DIALOG_WIDTH = 360;
export const COMPONENT_SHORTCUT_OPTION_TYPE = 'component' as const;
